import { Button, Container, Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { gradientBorder } from '../../assets/styles/button.style';
import AdditionalInfoModalComponent from '../common/additionalInfoModalComponent';


const AddInformationInfo = () => {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const addAdditionalInformationHandler = () => {
    setOpen(true);
  };

  return (
    <Container
      sx={{
        whiteSpace: 'nowrap',
        paddingBottom: 1.25,
        borderRadius: '6px',
      }}
    >
      <AdditionalInfoModalComponent open={open} handleClose={handleClose} />
      <Stack
        direction='column'
        alignItems='center'
        justifyContent='flex-end'
        spacing={2}
      >
        <Typography
          sx={{
            fontFamily: 'Schibsted Grotesk',
            fontSize: '1rem',
            fontWeight: 500,
            lineHeight: '1.188rem',
            letterSpacing: '0rem',
            textAlign: 'left',
            color: '#C0C0C0',
          }}
          variant='body2'
        >
          Do you wish to add additional information?
        </Typography>

        <Button
          onClick={addAdditionalInformationHandler}
          variant='outlined'
          sx={{ ...gradientBorder, width: '11.25rem' }}
        >
          Add
        </Button>
      </Stack>
    </Container>
  );
};

export default AddInformationInfo;
